import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';

import Close from 'Assets/images/icons/circle-bg-close.svg';

export type InteractCloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const InteractCloseButton = forwardRef<HTMLButtonElement, InteractCloseButtonProps>(
  ({ className, ...buttonProps }: InteractCloseButtonProps, ref) => (
    <button
      ref={ref}
      className={classNames(
        'button',
        'interactModal__fieldBar-selectField-item-closeIcon-button',
        className,
      )}
      {...buttonProps}
    >
      <ReactSVG
        src={Close}
        className="interactModal__fieldBar-selectField-item-closeIcon"
      />
    </button>
  ),
);

InteractCloseButton.displayName = InteractCloseButton.name;

export default InteractCloseButton;
